import { CalendarX2, RefreshCw } from 'lucide-react';
import { Reservation } from '../../../../types/restaurant/RestaurantReservationTypes';
import ReservationCard from './ReservationCard';

interface Props {
  reservations: Reservation[];
  loading: boolean;
  error: string;
  toleranceMinutes: number;
  onRetry: () => void;
  onEdit: (item: Reservation) => void;
  onConfirm: (item: Reservation) => void;
  onCancel: (item: Reservation) => void;
  onNoShow: (item: Reservation) => void;
  onOpenOrder: (item: Reservation) => void;
  isArrivalWindowOpen: (item: Reservation, tolerance: number) => boolean;
}

const ReservationList = ({
  reservations,
  loading,
  error,
  toleranceMinutes,
  onRetry,
  onEdit,
  onConfirm,
  onCancel,
  onNoShow,
  onOpenOrder,
  isArrivalWindowOpen,
}: Props) => {
  if (loading)
    return (
      <div className="grid gap-4 p-5 sm:p-7 lg:grid-cols-2">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-56 animate-pulse rounded-xl bg-gray dark:bg-boxdark-2"
          />
        ))}
      </div>
    );
  if (error)
    return (
      <div className="p-12 text-center">
        <p className="font-semibold text-danger">
          No fue posible cargar la agenda
        </p>
        <p className="mt-1 text-sm text-bodydark2">{error}</p>
        <button
          onClick={onRetry}
          className="mt-4 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white"
        >
          <RefreshCw className="h-4 w-4" />
          Reintentar
        </button>
      </div>
    );
  if (!reservations.length)
    return (
      <div className="p-14 text-center">
        <CalendarX2 className="mx-auto h-10 w-10 text-bodydark2" />
        <h2 className="mt-3 font-semibold text-black dark:text-white">
          No hay reservaciones
        </h2>
        <p className="mt-1 text-sm text-bodydark2">
          Pruebe otro rango o cree una nueva reservación.
        </p>
      </div>
    );
  return (
    <div className="grid gap-4 p-5 sm:p-7 md:hidden">
      {reservations.map((item) => (
        <ReservationCard
          key={item.id}
          reservation={item}
          arrivalWindowOpen={isArrivalWindowOpen(item, toleranceMinutes)}
          onEdit={() => onEdit(item)}
          onConfirm={() => onConfirm(item)}
          onCancel={() => onCancel(item)}
          onNoShow={() => onNoShow(item)}
          onOpenOrder={() => onOpenOrder(item)}
        />
      ))}
    </div>
  );
};

export default ReservationList;
